import React from 'react';
import { assignmentTypeOf, dueDateOf, dueState, financialYearOf, formatDate, normalizedStatus } from '../../utils/assignmentUtils';

function badge(status) {
  if (status === 'Completed') return 'bg-green-100 text-green-800';
  if (status === 'In Progress') return 'bg-blue-100 text-blue-800';
  return 'bg-gray-100 text-gray-800';
}

function dueBadge(state) {
  if (state === 'overdue') return <span className="text-xs font-semibold bg-red-100 text-red-700 rounded px-2 py-1">Overdue</span>;
  if (state === 'today') return <span className="text-xs font-semibold bg-yellow-100 text-yellow-800 rounded px-2 py-1">Due Today</span>;
  return null;
}

export default function AssignmentTable({ assignments, clientName, staffName, canManage, canEdit, onView, onEdit, onArchive }) {
  if (!assignments.length) return <div className="bg-white rounded-lg shadow p-8 text-center text-gray-500">No assignments found.</div>;
  return (
    <div className="bg-white rounded-lg shadow overflow-x-auto">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-100 text-left">
          <tr>
            <th className="px-4 py-3">Client</th>
            <th className="px-4 py-3">Assignment</th>
            <th className="px-4 py-3">FY / Period</th>
            <th className="px-4 py-3">Assigned To</th>
            <th className="px-4 py-3">Due Date</th>
            <th className="px-4 py-3">Status</th>
            <th className="px-4 py-3">Remarks</th>
            <th className="px-4 py-3">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y">
          {assignments.map((assignment) => {
            const due = dueState(assignment);
            return (
              <tr key={assignment.id} className={due === 'overdue' ? 'bg-red-50' : due === 'today' ? 'bg-yellow-50' : ''}>
                <td className="px-4 py-3 font-medium">{clientName(assignment)}</td>
                <td className="px-4 py-3">{assignmentTypeOf(assignment) || '—'}</td>
                <td className="px-4 py-3">{[financialYearOf(assignment), assignment.period].filter(Boolean).join(' / ') || '—'}</td>
                <td className="px-4 py-3">{staffName(assignment)}</td>
                <td className="px-4 py-3"><div className="flex flex-col gap-1"><span>{formatDate(dueDateOf(assignment))}</span>{dueBadge(due)}</div></td>
                <td className="px-4 py-3"><span className={`rounded-full px-2 py-1 text-xs font-semibold ${badge(normalizedStatus(assignment))}`}>{normalizedStatus(assignment)}</span></td>
                <td className="px-4 py-3 max-w-xs truncate" title={assignment.remarks || ''}>{assignment.remarks || '—'}</td>
                <td className="px-4 py-3 whitespace-nowrap space-x-2">
                  <button onClick={() => onView(assignment)} className="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300">View</button>
                  {canEdit(assignment) && <button onClick={() => onEdit(assignment)} className="px-2 py-1 bg-yellow-400 rounded hover:bg-yellow-500">Edit</button>}
                  {canManage && !assignment.isArchived && <button onClick={() => onArchive(assignment)} className="px-2 py-1 bg-red-600 text-white rounded hover:bg-red-700">Archive</button>}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
